import React from 'react';
import { config } from '@triare/auth-redux';

import Layout from '../../../components/Layout';
import ArticleByTypeViewContent from '../../../components/Pages/TippingArticles/ByTypeView';
import { WithArticleTypeProps } from '../../../hooks/api/articles';

const { displayName } = config;

/** Component for Articles which has types 'history' and 'psychology' */
export default function ArticleByTypeView({ articleType }: WithArticleTypeProps): React.ReactNode | null {
  document.title = `${displayName}: History Article`;

  return (
    <Layout>
      <ArticleByTypeViewContent articleType={articleType} />
    </Layout>
  );
}
